import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  Phone,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import useAjudante, { LOAD_MESSAGE } from './AjudanteHook'
import AjudanteModal from './AjudanteModal/AjudanteModal'

const Ajudante = ({ history, dispatch, selectedTp }) => {
  const { state, localDispatch } = useAjudante()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getAjudantes(state.selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage, state.selectedTp])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => localDispatch.onBtnExportarExcelClick(state.ajudantes)}>Exportar</Btn>
      </div>
    </CustomDataTableHeader>
  )

  return (
    <div>
      <PageHeader>2.17 - Cadastro de Ajudante</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={localDispatch.onBtnNovo} onVoltar={history.goBack}>
          <DataTable
            rows={10}
            paginator
            value={state.ajudantes}
            selectionMode="single"
            onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
            header={header}
            globalFilter={state.globalFilter}
            emptyMessage={'Não existem ajudantes cadastrados . . . '}
          >
            <Column field="id" header="Código" style={tableCellCentered(80)} />
            <Column field="name" header="Nome" />
            <Column field="cpf" header="CPF" style={tableCellCentered(130)} />
            <Column
              field="phone"
              header="Telefone"
              style={tableCellCentered(130)}
              body={ajudante => <Phone>{ajudante.phone}</Phone>}
            />
            <Column field="address" header="Endereço" />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered(80)}
              body={ajudante => <CustomCheckbox onChange={() => {}} checked={ajudante.actived} />}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <AjudanteModal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        ajudante={state.modal.data}
        selectedTp={state.selectedTp}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(Ajudante))

